module.exports = __webpack_public_path__ + "static/media/icon-w-navojoa.c0b3423e.png";